import { pageNames } from '@atc/bonnet-paths';

const blackListKeys = [
    'keywordsfyd',
    'make',
    'makeCodes',
    '0',
];

let fldWhiteListKeys = [
    'zip',
    'makeCode',
    'redirectExpiredPage',
];

let ddpWhiteListKeys = [
    'redirectExpiredPage',
    'dealerdetailstabs',
    '#reviews',
    '#sales',
    '#about',
    '#services',
    'listingType',
    'startYear',
    'endYear',
    'mileage',
    'modelCode',
    'trimCode',
    'minPrice',
    'maxPrice',
    'vehicleStyleCode',
    'driveGroup',
    'transmissionCode',
    'engineCode',
    'fuelTypeGroup',
    'mpgRange',
    'extColorSimple',
    'intColorSimple',
    'featureCode',
    'listingFeature',
    'dealType',
    'doorCode',
    'makeCode',
];

const blackListValues = [
    null,
    'null',
];

const isValidQueryParams = (queryParams = {}, pageName, isKbb) => {
    delete queryParams?.slug;
    if (isKbb) {
        fldWhiteListKeys = [...fldWhiteListKeys, 'brand'];
        ddpWhiteListKeys = [...ddpWhiteListKeys, 'brand'];
    }
    // Check whitelisted keys fld
    if (pageName === pageNames.DEALER_SEARCH) {
        for (const key in queryParams) {
            if (!fldWhiteListKeys.includes(key)) {
                return false;
            }
        }
    }
    // Check whitelisted keys ddp
    if (pageName === pageNames.DEALER_DETAILS) {
        for (const key in queryParams) {
            if (!ddpWhiteListKeys.includes(key)) {
                return false;
            }
        }
    }
    // Check blacklisted keys and values
    for (const [key, value] of Object.entries(queryParams)) {
        if (blackListKeys.includes(key) || blackListValues.includes(value)) {
            return false;
        }
    }
    return true;
};

export default isValidQueryParams;
